module.exports = __webpack_public_path__ + "img/Terraform-5-mobile.47262adb.png";